import { Link, Message } from '@bedrock/components';
import { ProText } from '@bedrock/eed-react';
import { EllipsisTooltip } from '@mpc/components';
import React from 'react';
import { FC } from 'react';
import { ProInputProps } from '@bedrock/eed-react';

export const ProTextEllipsis: FC<Partial<ProInputProps> & { clamp?: number }> = (
  props
) => {
  const { clamp = 1, ...restProps } = props;
  const render = (value: any) => {
    if (!value) return '-';
    return <EllipsisTooltip clamp={clamp} text={value} />;
  };
  return <ProText {...restProps} render={render} />;
};
